import clsx from "clsx";
import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import { Path, useFormContext } from "react-hook-form";

import { MaterialType } from "../../../../types/materials";
import { FormFieldLabel, Pill } from "../../elements";
import { TagColors, TagDimensions } from "../../elements/tags/types";
import { materialsOptions, otherMaterial } from "./constants";
import { MaterialOption, MaterialsFormFieldsLabels, MaterialsFormFieldsTypes } from "./types";

export interface MaterialsFormFieldsProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  labels: MaterialsFormFieldsLabels;
  materialsToShow?: MaterialOption[];
}

const mapMaterialsToTagColors: Record<MaterialOption, TagColors> = {
  [MaterialType.Wood]: TagColors.Wood,
  [MaterialType.Stone]: TagColors.Stone,
  [MaterialType.Glass]: TagColors.Glass,
  [MaterialType.Materia]: TagColors.Materia,
  [MaterialType.Metal]: TagColors.Metal,
  [otherMaterial]: TagColors.Primary,
};

export function MaterialsFormFields({
  labels,
  className,
  materialsToShow,
  ...rest
}: MaterialsFormFieldsProps) {
  const formMethods = useFormContext<MaterialsFormFieldsTypes>();
  const values = formMethods.watch("materials");
  return (
    <div className={clsx("flex flex-col gap-2", className)} {...rest}>
      <FormFieldLabel label={labels.materials} />
      <div className="flex gap-4 w-fit flex-wrap">
        {(materialsToShow ?? materialsOptions).map((materialOption) => {
          const name: Path<MaterialsFormFieldsTypes> = `materials.${materialOption}`;
          return (
            <Pill
              color={mapMaterialsToTagColors[materialOption]}
              key={materialOption}
              dimension={TagDimensions.Medium}
              className="font-medium"
              checked={values?.[materialOption] ?? false}
              {...formMethods.register(name)}
            >
              {labels[materialOption]}
            </Pill>
          );
        })}
      </div>
    </div>
  );
}
